const RUTA_GLOBAL = "/api/";

const HttpService = {
  async registrar(datos, ruta) {
    if (!ruta) return { error: "No se especificó archivo" };
    const respuesta = await fetch(RUTA_GLOBAL + ruta, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos)
    });
    return await respuesta.json();
  },

  async obtenerConDatos(datos, ruta) {
    if (!ruta) return { error: "No se especificó archivo" };
    const respuesta = await fetch(RUTA_GLOBAL + ruta, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos)
    });
    return await respuesta.json();
  },

  async obtener(ruta) {
    if (!ruta) return { error: "No se especificó archivo" };
    const respuesta = await fetch(RUTA_GLOBAL + ruta);
    return await respuesta.json();
  },

  async eliminar(ruta, datos) {
    if (!ruta) return { error: "No se especificó archivo" };
    const respuesta = await fetch(RUTA_GLOBAL + ruta, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos)
    });
    return await respuesta.json();
  }
};

export default HttpService;


// WEBPACK FOOTER //
// ./src/Servicios/HttpService.js